const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/report/performance-fte',
    authenticatedEntryPathAdminExpert: '/app/report/performance-fte',
    authenticatedEntryPathStandard: '/app/report/performance-fte',
    authenticatedEntryPathHotKey: '/app/leads/hotkey',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig